import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { filmPageData, filmFAQs } from "./FilmFacilities";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForFilm() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <>
      <BazAIHelmet
        title="AI-Powered Platform for the Film Industry"
        description="EkkBaz AI connects film producers, equipment suppliers, and finance providers on one intelligent platform — streamlining equipment procurement, automating cash flow management, and enabling embedded production financing."
        keywords="film production procurement, film equipment rental software, production financing, film industry B2B marketplace, equipment supplier management film, embedded finance film"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/industry/film`}
        industryName="Film"
        faqItems={filmFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Film Industry"
        subtitle="One AI platform connecting producers, equipment suppliers, and finance providers — enabling faster sourcing, smarter budgets, and embedded production financing."
        from="film"
      />
      <EnhancedPageLayout {...filmPageData} />
      <UpdateFooter />
    </>
  );
}
